import _ from 'underscore';
import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';
import { AdAssetsFormShimmer, AdAssetsPreviewerShimmer } from '@bingads-webui-campaign-react/pmax-lite-shimmers';

import { AdAssetsForm } from './components/ad-assets-form';
import { AdAssetsPreviewerUAPL } from './components/ad-assets-previewer-uapl';
import { getAdDataFromAssetGroupData } from './components/ad-assets-previewer-utils';
import { getAdAssetsStepViewStyles } from './ad-assets-step-view-styles';

export const AdAssetsStepView = (props) => {
  const {
    isLoading,
    data,
    previewTextAssets,
    imageListState,
    onSetCropImageObj,
    onSetEditingPlacementType,
    hideStepInfo,
  } = props;
  const i18n = useContext(I18nContext);
  const getStyles = useResponsiveStyles(getAdAssetsStepViewStyles);

  const {
    assetGroupData,
  } = data || {};

  const adData = useMemo(() => (
    getAdDataFromAssetGroupData(assetGroupData, previewTextAssets)
  ), [assetGroupData, previewTextAssets]);

  const formProps = useMemo(() => _.omit(props, 'hideStepInfo', 'isLoading'), [props]);

  return (
    <div className={classNames('ad-assets-step', getStyles('container'))}>
      <div className={classNames(getStyles('formContainer'))}>
        {isLoading ? (
          <AdAssetsFormShimmer />
        ) : (
          <React.Fragment>
            {!hideStepInfo && <h1 className={classNames(getStyles('title'))}>{i18n.getString(_TL_('Review your ads'))}</h1>}
            {!hideStepInfo && <p className={classNames(getStyles('description'))}>{i18n.getString(_TL_('Provide your assets (images and text) and we\'ll automatically determine what your ads look like, where and when they appear, and who sees them. We\'ll ensure that your ads have optimal asset combinations.'))}</p>}
            <AdAssetsForm
              {...formProps}
            />
          </React.Fragment>
        )}
      </div>
      <div className={classNames(getStyles('previewerContainer'))}>
        {isLoading ? (
          <AdAssetsPreviewerShimmer />
        ) : (
          <AdAssetsPreviewerUAPL
            i18n={i18n}
            imageListState={imageListState}
            onSetCropImageObj={onSetCropImageObj}
            onSetEditingPlacementType={onSetEditingPlacementType}
            {...adData}
          />
        )}
      </div>
    </div>
  );
};

AdAssetsStepView.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    assetGroupData: PropTypes.shape({}),
  }),
  previewTextAssets: PropTypes.shape({}).isRequired,
  imageListState: PropTypes.shape({}).isRequired,
  onSetCropImageObj: PropTypes.func.isRequired,
  onSetEditingPlacementType: PropTypes.func.isRequired,
  hideStepInfo: PropTypes.bool.isRequired,
};

AdAssetsStepView.defaultProps = {
  data: undefined,
};
